export class ListasUsuario {
  idioma: string[] = [];
  pais: string[] = [];
  vicepresidencia: string[] = [];
  correo_corporativo_jefe: string[] = [];
  nombre_posicion: string[] = [];
  lugar: string[] = [];
  area: string[] = [];
  direccion_gerencia: string[] = [];
}
